export const FLASH_SOLANA_MINT = '3p495oCmC4jsBrdLLny7Qm77mM62rUnQAgaBT6qNVTvg';
export const FLASH_SOLSCAN_URL = `https://solscan.io/token/${FLASH_SOLANA_MINT}`;

export const formatFlashBalance = (balance) => {
    const amount = Number(balance);
    if (!Number.isFinite(amount)) {
        return '0';
    }
    return amount.toLocaleString(undefined, { maximumFractionDigits: 6 });
};
